import CopyIcon from "@/assets/colorable/copy.svg?react";
import CopyToClipboardButton from "@/components/Common/CopyToClipboardButton";
import CollapsibleContent from "@/components/Common/forms/CollapsibleContent";
import PreviewButton from "@/components/Common/PreviewButton";
import {type FC} from "react";
import {useTranslation} from "react-i18next";
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {oneLight} from "react-syntax-highlighter/dist/esm/styles/prism";

const HighlightedHTMLTextArea: FC<{code: string; previewLink?: string}> = ({code, previewLink}) => {
  const {t} = useTranslation("referral");

  return (
    <div className="border-neutral-white-dark rounded-sm border">
      <span className="text-neutral-black text-2xs min-h-6 px-2 py-1">HTML</span>
      <CollapsibleContent longerContentClassName="pb-2" shownLinesLimit={10}>
        <div className="relative">
          <div className="absolute top-2 right-2 flex gap-1 md:gap-3">
            <CopyToClipboardButton
              collapseOnSmallerScreen
              className="h-fit min-h-7.5 w-fit px-5 py-1 text-sm"
              contentToCopy={code}
              label={t("copy")}
              icon={<CopyIcon className="size-3.5 shrink-0" />}
            />
            {previewLink && (
              <PreviewButton className="min-h-7.5" collapseOnSmallerScreen icon={null} link={previewLink} />
            )}
          </div>
          <SyntaxHighlighter
            language="html"
            style={oneLight}
            customStyle={{
              minHeight: "0",
              backgroundColor: "#FFFFFF",
              fontSize: "14px",
              margin: "0",
              padding: "8px",
            }}>
            {code.trim()}
          </SyntaxHighlighter>
        </div>
      </CollapsibleContent>
    </div>
  );
};

export default HighlightedHTMLTextArea;
